import { Text } from '@epam/promo';
import { FlexRow } from '@epam/uui-components';
import { LoginContainer } from 'components/layouts/LoginContainer';
import { useUserStore } from 'store/user.store';
import { useNavigate, Link } from 'react-router-dom';
import { useEffect } from 'react';
import NoAccessBotIcon from '../../assets/images/no-access-bot.png';
import css from './NoAccessPage.module.scss';

export const NoAccessPage = () => {
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    } else if (user.role !== 'GUEST') {
      navigate('/tasks', { replace: true });
    }
  }, [navigate, user]);

  return (
    <LoginContainer>
      <FlexRow cx={css.noAccessPage__info}>
        <Text cx={css.noAccessPage__title}>NO ACCESS</Text>
        <Text cx={css.noAccessPage__description} fontSize="18">
          Please, contact super admin at
        </Text>
        <Link
          className={css['noAccessPage__description--email']}
          to={`mailto:${process.env.REACT_APP_SUPER_ADMIN_EMAIL}`}
        />
      </FlexRow>
      <img alt="no access bot icon" src={NoAccessBotIcon} />
    </LoginContainer>
  );
};
